import { API_CONFIG } from '../config';

const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');

const normalizeConfiguredBaseUrl = (value = '') => {
  if (!value || value === 'relative') return '';
  return trimTrailingSlash(value);
};

export const joinApiUrl = (baseUrl, path = '') => {
  const normalizedBase = trimTrailingSlash(baseUrl || '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
};

export const getTriServeApiBaseUrl = () => normalizeConfiguredBaseUrl(
  API_CONFIG.TRISERVE_AUTH_API_URL || API_CONFIG.SALESFORCE_API_URL || API_CONFIG.TRISERVE_API_URL
);

export const getBillingApiBaseUrl = () => {
  const configuredBaseUrl = normalizeConfiguredBaseUrl(import.meta.env.VITE_BILLING_API_BASE_URL || '');
  if (configuredBaseUrl) return configuredBaseUrl;

  const triServeBaseUrl = normalizeConfiguredBaseUrl(API_CONFIG.TRISERVE_API_URL);
  return triServeBaseUrl ? joinApiUrl(triServeBaseUrl, '/billing') : '/api/billing';
};

export const AUTH_ROUTES = {
  login:        () => joinApiUrl(getTriServeApiBaseUrl(), API_CONFIG.AUTH_LOGIN_ENDPOINT        || '/api/v1/auth/login'),
  logout:       () => joinApiUrl(getTriServeApiBaseUrl(), API_CONFIG.AUTH_LOGOUT_ENDPOINT       || '/api/v1/auth/logout'),
  selfRegister: () => joinApiUrl(getTriServeApiBaseUrl(), API_CONFIG.AUTH_SELF_REGISTER_ENDPOINT || '/api/v1/auth/self-register'),
  verify:       () => joinApiUrl(getTriServeApiBaseUrl(), API_CONFIG.AUTH_VERIFY_ENDPOINT       || '/api/v1/auth/verify'),
  refreshToken: () => joinApiUrl(getTriServeApiBaseUrl(), API_CONFIG.AUTH_REFRESH_ENDPOINT      || '/api/v1/auth/refresh-token')
};

export const SALESFORCE_ROUTES = {
  accounts:    () => joinApiUrl(getTriServeApiBaseUrl(), '/api/v1/salesforce/accounts'),
  accountById: (id) => joinApiUrl(getTriServeApiBaseUrl(), `/api/v1/salesforce/accounts/${encodeURIComponent(id)}`),
  leads:       () => joinApiUrl(getTriServeApiBaseUrl(), '/api/v1/salesforce/leads'),
  leadById:    (id) => joinApiUrl(getTriServeApiBaseUrl(), `/api/v1/salesforce/leads/${encodeURIComponent(id)}`),
  accountsByIndustry: () => joinApiUrl(getTriServeApiBaseUrl(), '/api/v1/salesforce/accounts/by-industry')
};

export const PREFERENCES_ROUTES = {
  darkMode: () => joinApiUrl(getTriServeApiBaseUrl(), '/api/v1/me/preferences/dark-mode')
};

export const BILLING_ROUTES = {
  lookupAccount: (params) => `${getBillingApiBaseUrl()}/accounts/lookup?${params.toString()}`,
  currentBill:   (accountNumber) => `${getBillingApiBaseUrl()}/bills/current?accountNumber=${encodeURIComponent(accountNumber)}`,
  billingHistory: (accountNumber) => `${getBillingApiBaseUrl()}/bills/history?accountNumber=${encodeURIComponent(accountNumber)}`,
  payments:      () => `${getBillingApiBaseUrl()}/payments`
};
